module.exports = __webpack_public_path__ + "static/media/chevron-up-light.169128ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-up-light.svg
// module id = 322
// module chunks = 0